import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { ApiService } from "../../services/api.service";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "ngx-articles",
  templateUrl: "./articles.component.html",
  styleUrls: ["./articles.component.scss"],
})
export class ArticlesComponent implements OnInit {
  @ViewChild("carouselTrack") carouselTrack: ElementRef;
  @Input() address;
  translateX = 0;
  private startX = 0;
  private dragging = false;
  private initialTranslateX = 0;
  public articles;
  public articlesSliced;
  public n = 0;
  public forwardDisabled = false;
  public backwardsDisabled = true;

  private containerWidth: number;
  private trackWidth: number;
  constructor(
    private _http: ApiService,
    private _activatedRoute: ActivatedRoute,
    private _router: Router
  ) {}

  ngOnInit(): void {
    // (<any>$('.carousel')).carousel();
    // this._http.getNews().subscribe((item)=> {
    //   if(item) {
    //     this.articles = item;
    //     this.articlesSliced = this.articles.slice(this.n,this.n+4);
    //   }
    // })
    this.articles = [];
    this._activatedRoute.params.subscribe((paramsData: any) => {
      this._http
        .getCrowdsaleBlogs(paramsData.contractAddress, 0, 100)
        .subscribe((res) => {
          console.log(res);
          this.articles = res.articles;
          this.articlesSliced = this.articles.slice(
            this.n,
            this.articles.length
          );
        });
    });
  }

  ngAfterViewInit(): void {
    this.calculateWidths();
    window.addEventListener("resize", this.calculateWidths.bind(this));
  }

  carouselGoBack() {
    if (this.n - 1 != 0) {
      this.n -= 1;
      this.articlesSliced = this.articles.slice(this.n, this.n + 4);
      console.log(this.n);
    }
  }
  carouselGoForward() {
    if (this.n + 1 != this.articles.length - 3) {
      console.log("Value of N: " + this.n);
      console.log("Value of ln: " + this.articles.length);
      this.n += 1;
      if (this.n + 6 > this.articles.length) {
        // this.articlesSliced = this.articles.slice(this.n, this.articles.length - this.n)
      } else {
        this.articlesSliced = this.articles.slice(this.n, this.n + 6);
      }

      console.log(this.n);
    }
  }
  onDragStart(event: MouseEvent): void {
    this.dragging = true;
    this.startX = event.clientX;
    this.initialTranslateX = this.translateX;

    document.addEventListener("mousemove", this.onDrag.bind(this));
    document.addEventListener("mouseup", this.onDragEnd.bind(this));
  }

  onDrag(event: MouseEvent): void {
    if (this.dragging) {
      const deltaX = event.clientX - this.startX;
      const newTranslateX = this.initialTranslateX + deltaX;
      // Boundary checks
      if (newTranslateX > 0) {
        this.translateX = 0;
      } else if (newTranslateX < -this.maxTranslateX()) {
        this.translateX = -this.maxTranslateX();
      } else if (
        Math.abs(newTranslateX) >
        this.carouselTrack.nativeElement.scrollWidth - 1000
      ) {
        this.translateX = -this.maxTranslateX() + 1000;
      } else {
        this.translateX = newTranslateX;
      }
    }
  }

  onDragEnd(event: MouseEvent): void {
    this.dragging = false;

    document.removeEventListener("mousemove", this.onDrag.bind(this));
    document.removeEventListener("mouseup", this.onDragEnd.bind(this));
  }

  ngOnDestroy(): void {
    // Ensure event listeners are removed when the component is destroyed
    document.removeEventListener("mousemove", this.onDrag.bind(this));
    document.removeEventListener("mouseup", this.onDragEnd.bind(this));
    window.removeEventListener("resize", this.calculateWidths.bind(this));
  }

  calculateWidths(): void {
    if (this.carouselTrack && this.carouselTrack.nativeElement) {
      this.containerWidth =
        this.carouselTrack.nativeElement.parentElement.offsetWidth;
      this.trackWidth = this.carouselTrack.nativeElement.scrollWidth;
    }
  }

  maxTranslateX(): number {
    return this.carouselTrack.nativeElement.scrollWidth;
    // return Math.max(this.trackWidth - this.containerWidth, 0);
  }

  onClickArticle(id) {
    console.log(id);
    this._router.navigateByUrl(this.address + "/blog/" + id);
  }
}
